<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-router" trigger="hover" @command="onKindergartenChange" v-if="checkPermission([1, 11])">
        <div class="el-dropdown-link" style="cursor:pointer">
          {{ this.kindergartenName }}
          <i class="el-icon-d-caret"></i>
        </div>
        <el-dropdown-menu slot="dropdown" :data="principalKindergartenList">
          <el-dropdown-item v-for="( item ) in principalKindergartenList" :key="item.id" :command="item.id">{{ item.kindergartenName }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="avatar-router" trigger="hover" @command="onRoleChange">
        <div class="el-dropdown-link" style="cursor:pointer">
          {{ generateRole(this.roleName) }}
          <i class="el-icon-d-caret"></i>
        </div>
        <el-dropdown-menu slot="dropdown" :data="roleList">
          <el-dropdown-item v-for="( item,index ) in roleList" :key="index" :command="item.value">{{ generateRole(item.label) }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <lang-select class="right-menu-item hover-effect" />

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="@/assets/images/head.jpg" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item>
            <span style="display:block;" @click="logout">{{ $t('login.退出') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import checkPermission from '@/utils/permission'
import { getPrincipalKindergartenListData } from '@/api/principal-kindergarten'
import { getProTeacherKindergartenListData } from '@/api/pro-teacher-kindergarten'
import { getUserInfo } from '@/utils/auth'
import LangSelect from '@/components/LangSelect'
import { generateRole } from '@/utils/i18n'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar'])
  },
  data () {
    return {
      rolesData: [
        { value: 1, label: '园长' },
        { value: 2, label: '专家' },
        { value: 3, label: '教师' },
        { value: 4, label: '家长' },
        { value: 5, label: '幼儿园管理员' },
        { value: 6, label: '超级管理员' },
        { value: 7, label: '保健医' },
        { value: 8, label: '校车老师' },
        { value: 9, label: '集团领导' },
        { value: 10, label: '教育局领导' },
        { value: 11, label: '专业老师' },
        { value: 12, label: '招生老师' },
        { value: 14, label: '财务' },
        { value: 15, label: '集团管理员' },
        { value: 16, label: '集团招生老师' }

      ],
      roleList: [],
      principalKindergartenList: [],
      roleName: '',
      kindergartenName: '',
      labelList: ['园长', '专家', '教师', '家长', '幼儿园管理员', '超级管理员', '保健医', '校车老师', '集团领导', '教育局领导', '专业老师', '招生老师', '微信用户', '财务', '集团管理员', '集团招生老师']
    }
  },
  created () {
    this.show()
  },
  methods: {
    generateRole,
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    },
    checkPermission,
    show () {
      var userInfo = this.$store.getters.userInfo
      var roleId = userInfo.roleId
      var roles = userInfo.roles
      for (let [key, value] of this.rolesData.entries()) {
        if (value.value === roleId && key >= 0) {
          this.roleName = value.label
        }
        if (roles.includes(value.value)) {
          this.roleList.push({
            value: value.value,
            label: value.label
          })
        }
      }
      if (roleId === 1) {
        this.getPrincipalKindergartenList()
      } else if (roleId === 11) {
        this.getProTeacherKindergartenList()
      }
    },
    onRoleChange (role) {
      if (role) {
        this.$store.dispatch('user/switchRole', role).then(() => {
          if (role === 1) {
            this.getPrincipalKindergartenList()
          } else if (role === 11) {
            this.getProTeacherKindergartenList()
          }
          this.roleName = this.labelList[role - 1]
          this.$router.push({ path: '/' }).then(() => {
            location.reload()
          }).catch((err) => {
            console.log(err)
            location.reload()
          })
        })
      } else {
        return false
      }
    },
    getPrincipalKindergartenList () {
      getPrincipalKindergartenListData({ currentPage: 1, pageSize: 10000 }).then(response => {
        if (response.code === 200) {
          this.principalKindergartenList = response.data
          var userInfo = getUserInfo()
          for (let [key, value] of this.principalKindergartenList.entries()) {
            if (value.id === userInfo.kindergartenId && key >= 0) {
              this.kindergartenName = value.kindergartenName
              break
            }
          }
        }
      })
    },
    getProTeacherKindergartenList () {
      getProTeacherKindergartenListData({ currentPage: 1, pageSize: 10000 }).then(response => {
        if (response.code === 200) {
          this.principalKindergartenList = response.data
          var userInfo = getUserInfo()
          for (let [key, value] of this.principalKindergartenList.entries()) {
            if (value.id === userInfo.kindergartenId && key >= 0) {
              this.kindergartenName = value.kindergartenName
              break
            }
          }
        }
      })
    },
    onKindergartenChange (kindergartenId) {
      this.$store.dispatch('user/changeKindergarten', kindergartenId).then(() => {
        for (let [key, value] of this.principalKindergartenList.entries()) {
          if (value.id === kindergartenId && key >= 0) {
            this.kindergartenName = value.kindergartenName
            break
          }
        }
        this.$router.push({ path: '/' }).then(() => {
          location.reload()
        }).catch((err) => {
          console.log(err)
          location.reload()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-router {
  top: -16px;
  left: -50px;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue